module.exports = {"340711001":"桥南","340711002":"安矿","340711100":"铜山镇","340711101":"大通镇","340711198":"郊区虚镇","340711200":"灰河乡","340711400":"两矿一公司专管办","340711401":"大桥经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340711.json
// module id = 1000
// module chunks = 0